import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import {
  getCreditDetails,
  getLocations,
  reviewLists
} from 'src/common/Scraper';
import { lazy, useEffect, useRef, useState } from 'react';
import { broadcastService } from 'src/common/services/broadcastService';
import {
  Alert,
  Box,
  Breadcrumbs,
  Card,
  CardContent,
  Snackbar,
  Typography
} from '@mui/material';
import {
  keywordOverviewCss,
  snackBar
} from '../keywordResearch/keywordOverview/keywordOverviewCSS';
import {
  setBusinessNamesData,
  setIsConnectionFlow,
  setLocationListResponse,
  setLocationsDetailsLoader,
  setManageReviewsSection,
  setReduxFilteredLocationsData,
  setReduxLocationsData,
  setReviewList,
  setSelectedAccountId,
  setSelectedBusinessAccountId,
  setSelectedBusinessName,
  setSelectedBusinessNameFilter,
  setSelectedLocationId
} from 'src/redux/localSeo';
import {
  setIsAgencyUpgrade,
  setLocalSeoSection
} from 'src/redux/keywordResearch';
import { keywordResearchDashBoardCss } from '../keywordResearch/keywordResearchCSS';
import { GMBTutorialLinks, localSeoTexts } from './localSeoTexts';
import {
  keywordOverviewTexts,
  localSeoSignupSourceSqsp,
  localseoSignupSqspFlow,
  paths,
  SEOSpaceLocal
} from 'src/common/config/TextMessage';
import { useNavigate } from 'react-router';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import {
  getCookie,
  isLocalSeoUser,
  localStorageMethod,
  openNewTab
} from 'src/common/config/FunctionHelper';
import { Helmet } from 'react-helmet-async';
import { KeywordTrackingAllTexts } from '../keywordResearch/keywordTracking/KeywordTrackingAllTexts';
import {
  getLocalSeoBusinessId,
  getLocalSeoId,
  setLocalSeoBusinessId,
  setLocalSeoId,
  updateSearchesDetailsAndLimits
} from 'src/common/config/FunctionHelperPartTwo';
import { useChromeBrowserBanner } from 'src/hooks/useChromeBrowserBanner';
import { useBrowserType } from 'src/hooks/useBrowserType';
import { Outlet } from 'react-router-dom';
import Loader from 'src/common/config/Loader';
const ManageReviewsCards = Loader(
  lazy(() =>
    import('./ManageReviewsCards').then((module) => ({
      default: module.ManageReviewsCards
    }))
  )
);
const ManageReviewsTable = Loader(
  lazy(() =>
    import('./ManageReviewsTable').then((module) => ({
      default: module.ManageReviewsTable
    }))
  )
);
const ConnectBusinessProfileModal = Loader(
  lazy(() =>
    import('./ConnectBusinessProfileModal').then((module) => ({
      default: module.ConnectBusinessProfileModal
    }))
  )
);
const UpgradeToAgency = Loader(
  lazy(() =>
    import('../keywordResearch/keywordTracking/UpgradeToAgency').then(
      (module) => ({ default: module.UpgradeToAgency })
    )
  )
);
const LocalSeoCommonLoader = Loader(
  lazy(() =>
    import('./LocalSeoCommonLoader').then((module) => ({
      default: module.LocalSeoCommonLoader
    }))
  )
);
const NewCommonChromeExtensionModal = Loader(
  lazy(() =>
    import('src/common/NewCommomChromeExtensionModal').then((module) => ({
      default: module.NewCommonChromeExtensionModal
    }))
  )
);
const EmbedGoogleReviewsDashboard = Loader(
  lazy(
    () => import('./EmbedGoogleReviewsComponents/EmbedGoogleReviewsDashboard')
  )
);
const WidgetsDashboard = Loader(
  lazy(() => import('./EmbedGoogleReviewsComponents/WidgetsDashboard'))
);

export const ManageReviewsDashboard = () => {
  const [loader, setLoader]: any = useState(true);
  const [responseData, setResponseData]: any = useState(null);
  const [snackBarData, setSnackBarData]: any = useState(null);
  const [googleAuthText, setGoogleAuth] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [creditLoader, setCreditLoader]: any = useState(false);
  let selectedLocationId: any = useSelector(
    (state: RootState) => state.localSeo.selectedLocationId
  );
  const cleanedLocationId = selectedLocationId?.replace('locations/', '');
  let selectedAccountId: any = useSelector(
    (state: RootState) => state.localSeo.selectedAccountId
  );

  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  const isAgency =
    activePlanName === planDetails?.agency ||
    activePlanName === planDetails?.expertPlus ||
    activePlanName === planDetails?.enterprise;
  let selectedBusinessName: any =
    useSelector((state: RootState) => state.localSeo.selectedBusinessName) ??
    '';
  let reduxFilteredLocationsData: any =
    useSelector(
      (state: RootState) => state.localSeo.reduxFilteredLocationsData
    ) ?? null;
  let locationsData =
    useSelector((state: RootState) => state.localSeo.reduxLocationsData) ??
    null;
  const match = reduxFilteredLocationsData?.find(
    (location) => location?.title === selectedBusinessName
  );
  const localStorageSeoId = getLocalSeoId();
  const refreshMatch = reduxFilteredLocationsData?.find(
    (location) =>
      location?.name === localStorageSeoId && location?.temp !== true
  );

  const [selectedAddress, setSelectedAddress]: any = useState(
    //refreshMatch || match || reduxFilteredLocationsData?.[0] || ''
    ''
  );

  // useEffect to set when redux data arrives
  useEffect(() => {
    if (!reduxFilteredLocationsData || reduxFilteredLocationsData?.length === 0)
      return;

    const refreshMatch = reduxFilteredLocationsData?.find(
      (location) =>
        location?.name === localStorageSeoId && location?.temp !== true
    );

    setSelectedAddress(
      refreshMatch || match || reduxFilteredLocationsData?.[0] || ''
    );
  }, [reduxFilteredLocationsData, localStorageSeoId, match]); // run when any of these change

  let locationsDetailsLoader =
    useSelector((state: RootState) => state.localSeo.locationsDetailsLoader) ??
    null;
  let selectedBusinessAccountId: any = useSelector(
    (state: RootState) => state.localSeo.selectedBusinessAccountId
  );
  const isLocalSeo = isLocalSeoUser();
  const isLocalSeoUnlocked =
    useSelector((state: RootState) => state.localSeo.isLocalSeoUnlocked) ||
    isLocalSeo ||
    false;
  const isAgencyUpgrade =
    useSelector((state: RootState) => state.keywordResearch.isAgencyUpgrade) ??
    false;
  let stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  let isPremiumUser = useSelector((state: RootState) => state.user.premiumUser);
  const stripeLoader =
    useSelector((state: RootState) => state.siteAudit.stripeLoader) ?? true;
  let userDetails: any =
    useSelector((state: RootState) => state.counter.userDetails) ?? {};
  const loaderRedux =
    useSelector((state: RootState) => state.siteAudit.loader) ?? true;
  const manageReviewsSection =
    useSelector((state: RootState) => state.localSeo.manageReviewsSection) ?? 0;
  let isEditWidgetId: any =
    useSelector((state: RootState) => state.localSeo.isEditWidgetId) ?? null;
  let searchesDetailRedux = useSelector(
    (state: RootState) => state.keywordResearch.searchesDetails
  );
  // Check if the site audit loader is active
  const isFreePlan = activePlanName === planDetails.free;
  const isNoPlanAccount =
    !stripeLoader &&
    !loaderRedux &&
    userDetails?.email &&
    userDetails?.temp == true &&
    (!stripeSubscriptionDetails?.subscription_id || !isPremiumUser);
  const isExpireAccount =
    !stripeLoader &&
    !loaderRedux &&
    !isFreePlan &&
    userDetails?.email &&
    userDetails?.temp !== true &&
    (!stripeSubscriptionDetails?.subscription_id || !isPremiumUser);

  const isNoPlanOrExpire = isNoPlanAccount || isExpireAccount;

  const isNotPause =
    stripeSubscriptionDetails &&
    !stripeSubscriptionDetails?.pause_collection?.behavior;
  const locationStoredId = getLocalSeoId();
  const locationStoredBusinessId = getLocalSeoBusinessId();
  const cleanedStoredLocationId = locationStoredId?.replace('locations/', '');
  const getLocalSeoCookieSqsp = getCookie(localseoSignupSqspFlow) ?? null;
  const isLocalSeoSqsp = getLocalSeoCookieSqsp === localSeoSignupSourceSqsp;
  const { isChromeBrowser } = useBrowserType();
  const { NotAChromeBrowserBanner } = useChromeBrowserBanner();
  useEffect(() => {
    broadcastService.subscribe('manage-reviews-dashboard', {
      'gbpc_auth_connection': (data) => {
        dispatch(setSelectedBusinessAccountId(data?.accountId));
        setGoogleAuth(data);
      }
    });
    return () => broadcastService.unsubscribe('manage-reviews-dashboard');
  }, []);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const businessRef = useRef(null);
  const open = Boolean(anchorEl);

  const handleToggle = (event) => {
    setAnchorEl(open ? null : event.currentTarget);
  };

  useEffect(() => {
    if (
      location.pathname.includes('/widgets') ||
      location.pathname.includes('/embed')
    ) {
      navigate(paths?.googleReviews);
    }
    if (manageReviewsSection !== 0) {
      dispatch(setManageReviewsSection(0));
    }
    const fetchData = async () => {
      if (!locationsData) {
        await getLocationsDetails();
      }
    };

    fetchData();
    getCredits();
  }, []);

  useEffect(() => {
    if (
      (selectedAccountId && selectedLocationId) ||
      (locationStoredId && locationStoredBusinessId)
    ) {
      getReviewLists();
    } else if (
      ((!selectedAccountId && !selectedLocationId) ||
        (!locationStoredId && !locationStoredBusinessId)) &&
      isLocalSeoSqsp
    ) {
      getLocationsDetails();
    }
  }, [selectedAccountId, selectedLocationId]);

  useEffect(() => {
    if (snackBarData?.status) {
      setTimeout(() => {
        setSnackBarData(null);
      }, 3000);
    }
  }, [snackBarData]);

  useEffect(() => {
    if (
      googleAuthText?.message &&
      googleAuthText?.success &&
      location.pathname == paths?.googleReviews &&
      selectedBusinessAccountId
    ) {
      dispatch(setIsConnectionFlow(true));
      dispatch(setLocalSeoSection(1));
      navigate(paths?.localChecker);
      // Clear the authentication message after 5 seconds
      setTimeout(() => {
        setGoogleAuth(null);
      }, 5000);
    }
  }, [googleAuthText]);

  const getReviewLists = async () => {
    setLoader(true);
    // const locationId = cleanedLocationId ?? cleanedStoredLocationId;
    // const accountId = selectedAccountId ?? locationStoredBusinessId;
    const locationId = cleanedStoredLocationId ?? cleanedLocationId;
    const accountId = locationStoredBusinessId ?? selectedAccountId;
    
    const reviewListsResponse: any = await reviewLists(locationId, accountId);
    setSnackBarData(reviewListsResponse);
    if (reviewListsResponse?.status === 'success') {
      setResponseData(reviewListsResponse);
      dispatch(setReviewList(reviewListsResponse));
    } else {
      setResponseData([]);
      dispatch(setReviewList(null));
    }
    setLoader(false);
  };

  const handleCloseSnackBar = () => {
    setSnackBarData(null);
  };

  const getLocationsDetails = async (isConnecting = false) => {
    dispatch(setLocationsDetailsLoader(true));
    const squareSpaceSiteId = localStorageMethod('get', 'squareSpaceSiteId');
    const payload = {
      isConnecting,
      squareSpaceSiteId: squareSpaceSiteId ? squareSpaceSiteId : null
    };
    const getLocationsResponse: any = await getLocations(payload);
    dispatch(setLocationListResponse(getLocationsResponse));
    if (
      getLocationsResponse?.status == 'success' &&
      getLocationsResponse?.isGBPConnected
    ) {
      const locations = getLocationsResponse?.locations || [];
      // Filter only locations with selected === true
      const selectedLocations =
        locations?.filter(
          (location) => location?.selected === true && location?.temp !== true
        ) || [];

      // Dispatch filtered data to Redux
      dispatch(setReduxFilteredLocationsData(selectedLocations));
      dispatch(setReduxLocationsData(selectedLocations));
      dispatch(setSelectedBusinessName(selectedLocations[0]?.title));
      const locationStorageId = getLocalSeoId();
      const locationStorageBusinessId = getLocalSeoBusinessId();
      dispatch(
        setSelectedLocationId(
          locationStorageId ? locationStorageId : selectedLocations[0]?.name
        )
      );
      dispatch(
        setSelectedAccountId(
          locationStorageBusinessId
            ? locationStorageBusinessId
            : selectedLocations[0]?.accountId
        )
      );
      if (!locationStorageId && !locationStorageBusinessId) {
        setLocalSeoId(selectedLocations[0]?.name);
        setLocalSeoBusinessId(selectedLocations[0]?.accountId);
      }
      // Extract just the title values and dispatch
      const businessNames = locations?.map((loc) => loc?.title).filter(Boolean); // remove null/undefined
      dispatch(setBusinessNamesData(businessNames));
      if (isConnecting) {
        dispatch(setLocalSeoSection(1));
        navigate(paths?.localChecker);
      }
    } else {
      if (isConnecting) {
        dispatch(setLocalSeoSection(1));
        navigate(paths?.localChecker);
      }
    }
    dispatch(setLocationsDetailsLoader(null));
  };

  const handleSnackBarClose = () => {
    setGoogleAuth(null);
  };

  const breadcrumbs = [
    <Typography
      sx={keywordResearchDashBoardCss?.breadCrumbLightText}
      key="1"
      onClick={() => {
        navigate(paths?.otherTools);
      }}
    >
      {localSeoTexts?.localSeo}
    </Typography>,
    <Typography key="2" sx={keywordResearchDashBoardCss?.breadCrumbText}>
      {localSeoTexts?.googleReviews}
    </Typography>
  ];

  const breadcrumbsEmbedGoogleReviews = [
    <Typography
      sx={keywordResearchDashBoardCss?.breadCrumbLightText}
      key="1"
      onClick={() => {
        navigate(paths?.otherTools);
      }}
    >
      {localSeoTexts?.localSeo}
    </Typography>,
    <Typography
      key="2"
      sx={keywordResearchDashBoardCss?.breadCrumbLightText}
      onClick={() => {
        navigate(paths?.googleReviews);
        dispatch(setManageReviewsSection(0));
      }}
    >
      {localSeoTexts?.googleReviews}
    </Typography>,
    <Typography key="3" sx={keywordResearchDashBoardCss?.breadCrumbText}>
      {manageReviewsSection === 2
        ? localSeoTexts?.manageGoogleReviews
        : isEditWidgetId
        ? localSeoTexts?.updateGoogleReviewsWidget
        : localSeoTexts?.createGoogleReviewsWidget}
    </Typography>
  ];

  const handleSelect = (locationObj) => {
    setSelectedAddress(locationObj); // store the full object
    dispatch(setSelectedBusinessNameFilter(locationObj?.title));
    dispatch(setSelectedBusinessName(locationObj?.title));
    const matchedName = locationObj?.name || null;
    const matchedAccountId = locationObj?.accountId || null;
    setLocalSeoId(matchedName);
    setLocalSeoBusinessId(matchedAccountId);
    dispatch(setSelectedLocationId(matchedName));
    dispatch(setSelectedAccountId(matchedAccountId));

    const cleanedId = matchedName?.replace('locations/', '');
    setAnchorEl(null);
  };

  const getCredits = async () => {
    setCreditLoader(true);
    let getSearchesDetail;
    if (
      searchesDetailRedux &&
      ((Array.isArray(searchesDetailRedux) && searchesDetailRedux.length > 0) ||
        (!Array.isArray(searchesDetailRedux) &&
          Object.keys(searchesDetailRedux).length > 0))
    ) {
      getSearchesDetail = searchesDetailRedux;
    } else {
      getSearchesDetail = await getCreditDetails();
    }
    // let getSearchesDetail: any =  Array.isArray(searchesDetailRedux) && searchesDetailRedux.length > 0 ? searchesDetailRedux : await getCreditDetails();
    if (getSearchesDetail) {
      updateSearchesDetailsAndLimits(getSearchesDetail);
    }
    setCreditLoader(false);
  };

  const handleCloseUpgradeSnackBar = () => {
    dispatch(setIsAgencyUpgrade(false));
  };
  return (
    <>
      {/* Set the page title using the Helmet component */}
      <Helmet>
        <title>
          {isLocalSeo
            ? `${SEOSpaceLocal} | Google Reviews`
            : localSeoTexts.googleReviewsHelmetText}
        </title>
      </Helmet>
      {isAgencyUpgrade && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={isAgencyUpgrade}
          autoHideDuration={5000}
          onClose={handleCloseUpgradeSnackBar}
        >
          <Box>
            <Alert
              icon={
                <img
                  draggable={false}
                  src={
                    process.env.PUBLIC_URL +
                    `/static/images/icons/checkIcon.svg`
                  }
                  style={{
                    width: '40px',
                    height: '27px'
                  }}
                />
              }
              onClose={handleCloseUpgradeSnackBar}
              severity="success"
              variant="filled"
              sx={{
                ...snackBar?.alert,
                backgroundColor: 'var(--color-success-bg-ultra)',
                border: '1px solid var(--color-success-border)',
                maxWidth: '667px'
              }}
            >
              {KeywordTrackingAllTexts?.upgradeSuccessMessage}
            </Alert>
          </Box>
        </Snackbar>
      )}
      {googleAuthText?.message && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={googleAuthText?.message}
          autoHideDuration={5000}
          onClose={handleSnackBarClose}
        >
          <Box>
            <Alert
              icon={
                <img
                  draggable={false}
                  src={
                    process.env.PUBLIC_URL +
                    `/static/images/icons/checkIcon.svg`
                  }
                  style={{
                    width: '40px',
                    height: '27px'
                  }}
                />
              }
              onClose={handleSnackBarClose}
              severity="success"
              variant="filled"
              sx={{
                ...snackBar?.alert,
                backgroundColor: 'var(--color-success-bg-ultra)',
                border: '1px solid var(--color-success-border)',
                maxWidth: '667px'
              }}
            >
              {googleAuthText?.message}
            </Alert>
          </Box>
        </Snackbar>
      )}
      {snackBarData?.status && (locationsData || reduxFilteredLocationsData) && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={snackBarData?.status}
          autoHideDuration={3000}
          onClose={handleCloseSnackBar}
        >
          <Box>
            <Alert
              icon={
                snackBarData?.status === 'success' ? (
                  <img
                    draggable={false}
                    src={
                      process.env.PUBLIC_URL +
                      `/static/images/icons/checkIcon.svg`
                    }
                    style={{
                      width: '40px',
                      height: '27px'
                    }}
                  />
                ) : undefined // fallback to default icon
              }
              onClose={handleCloseSnackBar}
              severity={snackBarData?.status}
              variant="filled"
              sx={{
                ...(snackBarData?.status === 'success'
                  ? snackBar?.alert
                  : snackBar?.alertError),
                backgroundColor:
                  snackBarData?.status === 'success'
                    ? 'var(--color-success-bg-ultra)'
                    : 'var(--color-error-bg)',
                border:
                  snackBarData?.status === 'success'
                    ? '1px solid var(--color-success-border)'
                    : '1px solid var(--color-error-red)',
                maxWidth: '667px'
              }}
            >
              {snackBarData?.message}
            </Alert>
          </Box>
        </Snackbar>
      )}
      {!isLocalSeo && NotAChromeBrowserBanner}

      {isChromeBrowser &&
        !isNoPlanOrExpire &&
        !isFreePlan &&
        isNotPause &&
        !isLocalSeo && (
          <>
            <NewCommonChromeExtensionModal />
          </>
        )}
      <Box sx={keywordOverviewCss?.breadcrumbsMainBoxNew}>
        <Box>
          <Breadcrumbs
            separator={
              <NavigateNextIcon
                fontSize="small"
                sx={keywordResearchDashBoardCss?.navigateNextIcon}
              />
            }
            aria-label="breadcrumb"
          >
            {manageReviewsSection === 1 || manageReviewsSection === 2
              ? breadcrumbsEmbedGoogleReviews
              : breadcrumbs}
          </Breadcrumbs>
        </Box>
        <Box sx={keywordOverviewCss?.userTutorialBox}>
          <img
            onClick={() => {
              openNewTab(keywordOverviewTexts?.keywordResearchTutorialsLink);
            }}
            src={
              process.env.PUBLIC_URL +
              `/static/images/icons/keyword/book-open-02.svg`
            }
            alt="icon"
          />
          <Typography
            onClick={() => {
              openNewTab(GMBTutorialLinks?.localSeoTutorial);
            }}
            sx={keywordOverviewCss?.userTutorial}
          >
            {localSeoTexts?.tutorialText}
          </Typography>
        </Box>
      </Box>
      {locationsDetailsLoader || creditLoader ? (
        <LocalSeoCommonLoader />
      ) : (
        <>
          {(isAgency || isLocalSeoUnlocked) &&
          reduxFilteredLocationsData?.length === 0 &&
          reduxFilteredLocationsData ? (
            <ConnectBusinessProfileModal />
          ) : (isAgency || isLocalSeoUnlocked) && reduxFilteredLocationsData ? (
            <>
              {manageReviewsSection === 2 ? (
                <>
                  <WidgetsDashboard />
                </>
              ) : manageReviewsSection === 1 ? (
                <>
                  <EmbedGoogleReviewsDashboard />
                </>
              ) : (
                <>
                  {/*  This is where nested routes will render */}
                  <Outlet />
                  {/* Fallback when no child route is matched */}
                  {!location.pathname.includes('/widgets') &&
                    !location.pathname.includes('/embed') && (
                      <>
                        <ManageReviewsCards
                          loader={loader}
                          responseData={responseData}
                          businessRef={businessRef}
                          handleToggle={handleToggle}
                          selectedAddress={selectedAddress}
                          open={open}
                          anchorEl={anchorEl}
                          setAnchorEl={setAnchorEl}
                          locationsData={locationsData}
                          handleSelect={handleSelect}
                        />
                        <ManageReviewsTable
                          loader={loader}
                          responseData={responseData}
                          getReviewLists={getReviewLists}
                          isDelete={selectedAddress?.isDelete}
                        />
                      </>
                    )}
                </>
              )}
            </>
          ) : (isAgency || isLocalSeoUnlocked) &&
            (!locationsData || !reduxFilteredLocationsData) ? (
            <ConnectBusinessProfileModal />
          ) : !isAgency && !isLocalSeoUnlocked && activePlanName ? (
            <Card sx={{ ...keywordOverviewCss?.card }}>
              <CardContent sx={keywordOverviewCss?.cardContent}>
                <UpgradeToAgency isLocalSeo={true} isReviews={true} />
              </CardContent>
            </Card>
          ) : (
            <LocalSeoCommonLoader />
          )}
        </>
      )}
    </>
  );
};
